<template>
  <div id="app">
    <aside-nav v-if="isLoggedIn && toggleSidebar"></aside-nav>
    <router-view/>
    <notifications></notifications>
    <div class="loading" v-if="loading">
      <img src="/static/img/waiting.gif" alt="" class="loading__image">
    </div>
  </div>
</template>

<script>
import asideNav from '@/components/layout/nav'
import notifications from '@/components/layout/notifications'
import {auth} from '@/assets/js/libs/sessions'
export default {
  name: 'App',
  components: {
    asideNav,
    notifications
  },
  created: function () {
    this.validateLogin()
  },
  methods: {
    validateLogin: function () {
      auth.loggedIn(this.$route)
        .then(
          response => {
            if (response.auth) {
              this.$store.commit('login')
            } else {
              this.$store.commit('logout')
            }
          }
        )
    }
  },
  computed: {
    loading: function () {
      return this.$store.state.loading
    },
    isLoggedIn: function () {
      return this.$store.state.isLoggedIn
    },
    toggleSidebar: function () {
      return this.$store.state.toggleSidebar
    }
  }
}
</script>

<style lang="sass">
@import "/assets/sass/elements/_base"
@import "/assets/sass/objects/_generic"
@import "/assets/sass/components/layout/_content"
</style>



// WEBPACK FOOTER //
// src/App.vue